import React from "react"

const AttemptRow = React.memo(function AttemptRow({ attempt, index, animate }) {
  const isSkipped = attempt.skipped
  return (
    <div
      className={`gs-attempt-row ${isSkipped ? "skipped" : attempt.correct ? "correct" : "wrong"} ${animate ? "animate" : ""}`}
      style={{ animationDelay: animate ? `${index * 0.06}s` : "0s" }}
    >
      <span className="gs-attempt-num">#{attempt.attempt_number}</span>
      {attempt.icon_url && <img src={attempt.icon_url} alt="" className="gs-attempt-icon" />}
      <span className="gs-attempt-name">{attempt.user_answer}</span>
      <span className={`gs-attempt-badge ${isSkipped ? "skip" : attempt.correct ? "ok" : "fail"}`}>
        {isSkipped ? "⊘ Skipped" : attempt.correct ? "✓ Correct" : "✗ Wrong"}
      </span>
    </div>
  )
})

export default AttemptRow
